// Requirements summary: browser storage can throw in Mobile Safari/privacy
// contexts, so UI preferences must fall back without interrupting auth flows.

export type BrandTheme = 'v1' | 'v2';

export const BRAND_THEME_STORAGE_KEY = 'brand-theme';
export const DEFAULT_BRAND_THEME: BrandTheme = 'v2';

export function safeLocalStorageGetItem(key: string): string | null {
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSetItem(key: string, value: string): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeLocalStorageRemoveItem(key: string): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function safeLocalStorageClear(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.clear();
    return true;
  } catch {
    return false;
  }
}

export function safeSessionStorageGetItem(key: string): string | null {
  if (typeof window === 'undefined') return null;

  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSessionStorageSetItem(key: string, value: string): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeSessionStorageRemoveItem(key: string): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function safeSessionStorageClear(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    window.sessionStorage.clear();
    return true;
  } catch {
    return false;
  }
}

export function safeLocalStorageLength(): number {
  if (typeof window === 'undefined') return 0;

  try {
    return window.localStorage.length;
  } catch {
    return 0;
  }
}

export function safeLocalStorageKey(index: number): string | null {
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage.key(index);
  } catch {
    return null;
  }
}

export function getStoredBrandTheme(): BrandTheme {
  return safeLocalStorageGetItem(BRAND_THEME_STORAGE_KEY) === 'v1'
    ? 'v1'
    : DEFAULT_BRAND_THEME;
}

export function setStoredBrandTheme(theme: BrandTheme): boolean {
  return safeLocalStorageSetItem(BRAND_THEME_STORAGE_KEY, theme);
}
